import { AlertTriangle } from 'lucide-react';
import React from 'react';
import './styles/FullScreenError.css';

export interface ErrorProps {
    message?: string;
    onRetry?: () => void;
}

const AppError: React.FC<ErrorProps> = ({
    message = 'Произошла ошибка при загрузке данных. Мы уже работаем над этим.',
    onRetry,
}) => {
    return (
        <div className='error-card'>
            <AlertTriangle size={48} color="#ff6363" />
            <div className="error-title">Упс!</div>
            <div className="error-message">{message}</div>

            {onRetry && (
                <button className="retry-button" onClick={onRetry}>
                    Повторить
                </button>
            )}
        </div>
    );
};

export default AppError;